import {Button} from '@orbit-ui/components/button';
import {Card, CardContent, CardHeader, CardTitle} from '@orbit-ui/components/card';
import {PageHeader} from '@orbit-ui/components/page-header';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@orbit-ui/components/table';
import {PlusIcon} from 'lucide-react';

export const TenantsOverviewView = () => {
  const tenants = [
    {id: 1, name: 'Acme Corp', status: 'Active', users: 42, createdAt: '2024-11-15'},
    {id: 2, name: 'TechStar', status: 'Active', users: 27, createdAt: '2024-12-20'},
    {id: 3, name: 'Global Services', status: 'Inactive', users: 5, createdAt: '2025-01-10'},
  ];

  return (
    <div className="container mx-auto space-y-6 py-6">
      <PageHeader
        title="Tenants Overview"
        description="Manage your organization's tenants"
        action={
          <Button size="sm">
            <PlusIcon className="mr-2 size-4" />
            Add Tenant
          </Button>
        }
      />

      <Card>
        <CardHeader>
          <CardTitle>Tenants</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Users</TableHead>
                <TableHead>Created</TableHead>
                <TableHead className="text-right">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tenants.map((tenant) => (
                <TableRow key={tenant.id}>
                  <TableCell className="font-medium">{tenant.name}</TableCell>
                  <TableCell>
                    <span
                      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                        tenant.status === 'Active'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-red-100 text-red-800'
                      }`}
                    >
                      {tenant.status}
                    </span>
                  </TableCell>
                  <TableCell>{tenant.users}</TableCell>
                  <TableCell>{tenant.createdAt}</TableCell>
                  <TableCell className="text-right">
                    <Button variant="ghost" size="sm">
                      View
                    </Button>
                    <Button variant="ghost" size="sm">
                      Edit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};
